import { gql } from "@apollo/client";

export const CREATE_PROFESIONAL_DERIVADOR = gql`
mutation CreateProfesionalDerivadorFull($input: AddProfesionalDerivadorFullInput!) {
  createProfesionalDerivadorFull(input: $input) {
    success,
    error,
    valorEsperado
  }
}
`;